import { Card, CardBody, Col } from "reactstrap";
import { AnimatedColorDividerTitle } from "../../../Constants/Constants";
import { AnimatedColorDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { P } from "../../../AbstractElements";

const AnimatedColorDivider = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={AnimatedColorDividerTitle} span={AnimatedColorDividerSubTitle} />
        <CardBody className="linear-divider">
          <div className="animated-divider animated-line" />
          <P className="mb-0 c-light">This CSS divider embodies simplicity at its finest, yet it exudes an air of elegance and timelessness. Despite its minimalist design, it commands attention effortlessly. While the divider takes center stage in this arrangement, it seamlessly integrates with the overall aesthetic, allowing the backdrop image to shine through.</P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AnimatedColorDivider;
